import { z } from 'zod'

/**
 * この正規表現は、以下の条件を満たす電話番号を許容します：
 *
 * 0から始まる電話番号（固定電話）： 0で始まり、その後に9桁または10桁の数字が続く。
 * ハイフンが含まれないようにする。
 */
const validatePhoneNumber = (val: string): boolean => {
  return /^0\d{9,11}$/.test(val)
}

const validatePostalCode = (val: string): boolean => {
  return /^[0-9]{7}$/.test(val)
}

export const phoneNumber = (
  val: z.ZodString,
): z.ZodEffects<z.ZodString, string> =>
  val.refine(validatePhoneNumber, {
    message: '電話番号を正しく入力してください',
  })

export const postalCode = (
  val: z.ZodString,
): z.ZodEffects<z.ZodString, string> =>
  val.refine(validatePostalCode, {
    message: '7文字の半角数字で入力してください',
  })

export const notEmpty = <T extends z.ZodTypeAny>(
  val: z.ZodArray<T>,
): z.ZodEffects<z.ZodArray<T>, z.infer<T>[]> =>
  val.refine((val) => val.length > 0, { message: '必須項目です' })

export const arrayLength = <T extends z.ZodTypeAny>(
  val: z.ZodArray<T>,
  length: number,
): z.ZodEffects<z.ZodArray<T>, z.infer<T>[]> =>
  val.refine((val) => val.length === length, {
    message: `${length}件入力してください`,
  })

export const length = (
  val: z.ZodString,
  length: number,
): z.ZodEffects<z.ZodString, string> =>
  val.refine((val) => val.length === length, {
    message: `${length}文字で入力してください`,
  })

export const range = (
  val: z.ZodNumber,
  min: number,
  max: number,
): z.ZodEffects<z.ZodNumber, number> =>
  val.refine((val) => min <= val && val <= max, {
    message: `${min}以上、${max}以下の値で入力してください`,
  })
